import { ProductForm } from '@modules/products';
import { Modal } from '@shared/ui';
import { Loader } from '@mantine/core';
import { useEditProductForm } from '../../hooks/useEditProductForm';
import './EditProductModal.css';

interface EditProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  productId: number;
  onSuccess?: (result?: { wentToModeration: boolean }) => void;
}

export default function EditProductModal({
  isOpen,
  onClose,
  productId,
  onSuccess,
}: EditProductModalProps) {
  const {
    product,
    productLoading,
    initialValues,
    handleSubmit,
    isSubmitting,
  } = useEditProductForm(productId, {
    onDone: onClose,
    onSuccess,
  });

  const modalTitle = product
    ? `Редактировать: ${product.name}`
    : 'Редактировать товар';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={modalTitle} maxWidth={1200}>
      <div className="edit-product-modal-content">
        {productLoading ? (
          <div
            className="empty-container"
            style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}
          >
            <Loader />
          </div>
        ) : (
          product && (
            <ProductForm
              onSubmit={handleSubmit}
              initialValues={initialValues}
              isEdit={true}
              isLoading={isSubmitting}
            />
          )
        )}
      </div>
    </Modal>
  );
}
